// Public site base + URL builders for CMS-style permalinks in the admin.
// Must be the LIVE public site: the *-staging.workers.dev host is wired to the
// dead staging API (404s), so its listing pages never hydrate.
export const PUBLIC_SITE = "https://avestate.avstudio.ai";

export const listingUrl = (slug: string) => `${PUBLIC_SITE}/listing/${encodeURIComponent(slug)}`;
export const postUrl = (slug: string) => `${PUBLIC_SITE}/blog/?slug=${encodeURIComponent(slug)}`;
export const pageUrl = (page: string) => (page === "home" ? `${PUBLIC_SITE}/` : `${PUBLIC_SITE}/${page}`);
